import { render, staticRenderFns } from "./publishAudit.vue?vue&type=template&id=1423f2f4&scoped=true&"
import script from "./publishAudit.vue?vue&type=script&lang=js&"
export * from "./publishAudit.vue?vue&type=script&lang=js&"
import style0 from "@assets/css/publish/publishAudit.less?vue&type=style&index=0&id=1423f2f4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1423f2f4",
  null
  
)

component.options.__file = "publishAudit.vue"
export default component.exports